import './global.js'
import Parse from 'parse';
import React from 'react';
import { Route, Link} from "react-router-dom";
import Leftsidebar from "./Leftsidebar.jsx";
import CommonPopup from './CommonPopup.jsx';
import $ from "jquery";

class ExploreListing extends React.Component {

    constructor(props) {
        super(props);

        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

        var now = new Date();

        this.state = {
            challenges: {},
            users: {},
            posts: {},
            created_at: now.getTime(),
            isPopupOpen: false,
            post_common_id:''
        };
        this.queryForChallengeData();
        this.queryForPostsData();
        localStorage.setItem('storestreamtabValue', 'explore');
        localStorage.setItem('storestreampagepath', 'explore');
    }
    queryForChallengeData()
    {
        var query = new Parse.Query('Photo');
        query.equalTo('isChallenge',"1");
       // query.containedIn('challengeStatus',["Active","Billed"]);
         query.containedIn('challengeStatus',["Active"]);
        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("_created_at");
        query.include("createdAt");
        query.exists("user");
        query.descending("createdAt");



       // query.limit(4);
        var self = this;

        query.find().then(function(result){
            if(result){
                //console.log(result);
                self.setState({challenges: result});
            } else {
                console.log("No challenge found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });
    }
    queryForPostsData()
    {
        var query = new Parse.Query('Photo');
        
        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("_created_at");
        query.include("createdAt");
        query.doesNotExist("isChallenge");
        query.select("isChallengeWinner");
        query.select("isChallengeEntry");
        query.select("image");
        query.select("thumbnail");
        query.select("isRecipe");
        query.exists("user");
        query.descending("createdAt");
        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({posts: result});
            } else {
                console.log("No post found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });
    }

renderChallenges()
{
    let buffer = [];
    let bufferrecord = [];
    let bufferpost = [];
    let bufferpostrecord = [];
    var isPopupOpen= this.state.isPopupOpen;
    var postcommonid= this.state.post_common_id;
   
    const togglePopup = (postid) => {
        this.setState(prevState => ({
          isPopupOpen: !prevState.isPopupOpen,
        }));
        this.setState({ post_common_id: postid });
        
      };
      const streamid= (postid) =>{
           localStorage.setItem('storestreamid', postid);
      }

        if (this.state.challenges)
        {
            let activeclass='';
            for (var i = 0; i < this.state.challenges.length; i++)
            {
                var post = this.state.challenges[i];
            
                /*buffer.push(<div className='card_box' key={69*i}>
                    <div>{post.id}</div>
                   <SinglePost postData={post}/>
                </div>);*/
                activeclass=i===0?"carousel-item active":'carousel-item';

                buffer.push(<li data-target="#explr-lis-indicatr" data-slide-to={i} className={`${i == 0 ? 'active' : ''}`}  key={69*i}> 
                </li>);


                bufferrecord.push(<div className={`carousel-item ${i == 0 ? 'active' : ''}`} key={69*i}>
                                        <div className='listing-box'>
                                         <a href={"/challenge/"+post.id}  className=''>
                                            <div className='bg-img'>
                                               {/* <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />*/}
                                            <img className="d-block w-100" src={post.get("image")?post.get("image").url():''} alt={post.get('challengeTitle')?post.get('challengeTitle'):""} />         
                                            </div>
                                            <div className='detail'>
                                              <h1> {post.get('challengeTitle')?post.get('challengeTitle'):""}</h1>
                                                <h2>{post.get('prize')?"$"+post.get('prize').toString().replace(/,/g,"").replace(/\B(?=(\d{3})+(?!\d))/g, ",")+" in prizes":""}</h2>
                                                <h3>{post.get('businessAccount')?"Sponsored by "+post.get('businessAccount'):''}</h3>
                                            </div>
                                            </a>
                                        </div>
                                    </div>);

            }
        }

        if (this.state.posts)
        {
            for (var i = 0; i < this.state.posts.length; i++)
            {

{/*href='javascript:void(0);' onClick={(e) => {togglePopup(postdata_id);}}*/}
                 var postdata = this.state.posts[i];
                 let postdata_id=postdata.id;
                 bufferpostrecord.push( <div className="gridPost"  key={i+100}>
                        {/* <button title={postdata_id} onClick={(e) => {togglePopup(postdata_id);}}>Open Popup</button>*/}
                          <a href = "/stream" onClick={(e) => {streamid(postdata_id);}} >
                                       {/*  <a href={"/post/"+postdata.id}>*/} 
                                        {/*postdata.get('isChallengeEntry')*/} 
                                     <div className='chlng-icon'>
                                        {/*<div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>*/}
                                      {/*  <div className='winner'><img src="../images/winner-icon-img.svg"/></div>*/}
                                        {/*<div className='winner entry'><img src='/images/chlng-entry-big.svg' className='chlng-wnr' /></div>*/}
                                {postdata.get("isChallengeWinner")!==undefined && postdata.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                {/*postdata.get("isChallengeEntry")!==undefined && postdata.get("isChallengeEntry")==="1" && !postdata.get("isChallengeWinner") && <img src='/images/chlng-entry.png' className='chlng-wnr' />*/}
                                {postdata.get("isRecipe")!==undefined && postdata.get("isRecipe")===true &&  <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>

                                            <figure className="thumbnail">
                                                <img  src={postdata.get("image")?postdata.get("image").url():''} />
                                            </figure>
                                        </a>
                                    </div>);

            }

        }

        return (  <main className='listing explr-list'> <div id="explr-lis-indicatr" className="carousel slide" data-ride="carousel"> <ol className="carousel-indicators">{buffer}  </ol>

            <div className="carousel-inner">
              {bufferrecord}
            </div>
           {/* <ol className="carousel-indicators">
                                    <li data-target="#explr-lis-indicatr" data-slide-to="0" className="active"></li>
                                    <li data-target="#explr-lis-indicatr" data-slide-to="1"></li>
                                    <li data-target="#explr-lis-indicatr" data-slide-to="2"></li>
                                </ol>
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <div className='listing-box'>
                                            <div className='bg-img'>
                                                <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />
                                            </div>
                                            <h1>Soup for the Soul</h1>
                                            <div className='detail'>
                                                <h2>$1,000 in prizes</h2>
                                                <h3>Sponsored by joelskitchen</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className='listing-box'>
                                            <div className='bg-img'>
                                                <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />
                                            </div>
                                            <h1>Soup for the Soul</h1>
                                            <div className='detail'>
                                                <h2>$1,000 in prizes</h2>
                                                <h3>Sponsored by joelskitchen</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className='listing-box'>
                                            <div className='bg-img'>
                                                <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />
                                            </div>
                                            <h1>Soup for the Soul</h1>
                                            <div className='detail'>
                                                <h2>$1,000 in prizes</h2>
                                                <h3>Sponsored by joelskitchen</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>*/}
                                <a className="carousel-control-prev" href="#explr-lis-indicatr" role="button" data-slide="prev">
                                    <img src="/images/sld-arrow.svg" alt="Prev" />
                                </a>
                                <a className="carousel-control-next" href="#explr-lis-indicatr" role="button" data-slide="next">
                                    <img src="/images/sld-arrow.svg" alt="Next" />
                                </a>
                            </div>
                             <div className='explr_list_grid'> 
                                <div className="gridPostRow">
                                {bufferpostrecord}
                                 </div>
                              
                            </div>
                        
      <CommonPopup   isOpen={isPopupOpen} onClose={(e) => {togglePopup(postcommonid);} } postcommonid={postcommonid} />   

                </main>
        //}
        );

}

    render() {    
 
    
        return (
            <section className='post_list'> 
                <div className='container'>
                    <div className='inner'>
                        <nav className='sidebar'>
                            <Leftsidebar/>
                        </nav>
                      
                              {this.renderChallenges()}
                                {/*<ol className="carousel-indicators">
                                    <li data-target="#explr-lis-indicatr" data-slide-to="0" className="active"></li>
                                    <li data-target="#explr-lis-indicatr" data-slide-to="1"></li>
                                    <li data-target="#explr-lis-indicatr" data-slide-to="2"></li>
                                </ol>
                                */}
                                {/*<div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <div className='listing-box'>
                                            <div className='bg-img'>
                                                <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />
                                            </div>
                                            <h1>Soup for the Soul</h1>
                                            <div className='detail'>
                                                <h2>$1,000 in prizes</h2>
                                                <h3>Sponsored by joelskitchen</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className='listing-box'>
                                            <div className='bg-img'>
                                                <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />
                                            </div>
                                            <h1>Soup for the Soul</h1>
                                            <div className='detail'>
                                                <h2>$1,000 in prizes</h2>
                                                <h3>Sponsored by joelskitchen</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className='listing-box'>
                                            <div className='bg-img'>
                                                <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />
                                            </div>
                                            <h1>Soup for the Soul</h1>
                                            <div className='detail'>
                                                <h2>$1,000 in prizes</h2>
                                                <h3>Sponsored by joelskitchen</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>*/}
                               
                            
                           
                                   {/* <div class="gridPost">
                                        <a href="/post/pasdunb4ED">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg"/>
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/2EsYcZIBii">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/WmL3QeLgGE">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/2EsYcZIBii">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/WmL3QeLgGE">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>*/}
                               
                       
                    </div>
                </div>
            </section>      
        );
    }
}

export default ExploreListing;


// WEBPACK FOOTER //
// ./src/ExploreListing.jsx